import React from 'react';
import { wagwebTheme } from '@/theme/wagwebTheme';
import background from '@/assets/illustrations/wagcompare.jpg';
import logoIcon from '@/assets/icons/wagcomparelogo.svg';
import { GenericHealthArticleAdvertCard } from '../Generic/Generic';
import { BoxProps } from '../../../wag-react/next-components/box';
type WagCompareHealthArticleAdvertCardProps = Omit<BoxProps, 'background'> & {
  buttonHref?: string;
};
export const WagCompareHealthArticleAdvertCard = ({
  buttonHref,
  ...props
}: WagCompareHealthArticleAdvertCardProps) => <GenericHealthArticleAdvertCard subheading="Get a free pet insurance quote in less than 60 seconds!" content="Easily compare quotes from the most trusted pet insurance companies in the United States." button={{
  backgroundColor: 'white',
  textColor: '#4EB387',
  label: 'Get a quote',
  href: buttonHref
}} background={{
  src: background,
  type: 'full'
}} logo={{
  alt: 'Wag Compare logo',
  src: logoIcon
}} contentProps={{
  maxWidth: '350px'
}} hoverTextColor="white" hoverBackgroundColor={wagwebTheme.colors.tropicalRainForest} {...props} data-sentry-element="GenericHealthArticleAdvertCard" data-sentry-component="WagCompareHealthArticleAdvertCard" data-sentry-source-file="Compare.tsx" />;